import './App.css';
import React from "react";
import { useState, useEffect } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SearchFilter from "./components/SearchFilter";
import TableHeader from './components/TableHeader';
import TableRow from './components/TableRow';

function App() {

  const [listInfo, setListInfo] = useState([]);
  const [filteredList, setFilteredList] = useState(listInfo); 
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [isOnDescription, setIsOnDecription] = useState(false);
  const [isTranslateAll, setIsTranslateAll] = useState(false);

  // Cập nhật danh sách khi thay đổi startYear hoặc endYear
  useEffect(() => {
    if (!startYear && !endYear) {
      setFilteredList(listInfo);
      return;
    }

    const filtered = listInfo.filter((item) => {
      const releaseYear = new Date(item.release_date).getFullYear();
      return (!startYear || releaseYear >= startYear) && (!endYear || releaseYear <= endYear);
    });

    setFilteredList(filtered);
  }, [startYear, endYear, listInfo]);
      

  const handleDelete = (app_id)=>{
    setListInfo((prevList) => prevList.filter((app) => app.app_id !== app_id));
  }

  const [alert, setAlert] = useState(null);
  const showAlert = (message, type = "info") => {
    setAlert({ message, type });
  };



  return (
    <>
      {alert && (
        <div className="fixed top-5 right-5 p-4 text-white rounded shadow-lg bg-blue-500 flex items-center space-x-3 z-50">
          <span className="text-lg">{alert.message}</span>
          <AiOutlineLoading3Quarters className="animate-spin text-white text-2xl" />
        </div>
      )}


      <div className="flex flex-col items-start min-h-screen mt-2 ">
        
        <SearchFilter
          startYear={startYear}
          setStartYear={setStartYear}
          endYear={endYear}
          setEndYear={setEndYear}
          showAlert = {showAlert}
          setListInfo = {setListInfo}
          setAlert = {setAlert}
          listInfo = {listInfo}
          isOnDescription={isOnDescription}
          setIsOnDecription={setIsOnDecription}
          isTranslateAll = {isTranslateAll}
          setIsTranslateAll = {setIsTranslateAll}
        />

        <table className="min-w-full border-collapse border border-gray-300 shadow-lg rounded-lg overflow-hidden">
          <TableHeader
            listInfo={listInfo}
            setListInfo={setListInfo}
          />
          <tbody>
              {(startYear && endYear ? filteredList : listInfo).map((item, index) => (               
                <TableRow key={item.app_id || index} item={item} index={index} handleDelete={handleDelete} 
                isOnDescription={isOnDescription} isTranslateAll={isTranslateAll}/>
              ))}
          </tbody>
      </table>

    </div>


    </>

  );
}

export default App;
